import type { FieldValues, UseFormReturn } from 'react-hook-form';

import { useManageSubmit } from './useManageSubmit';



/**
 * This hook is used to manage the form. It returns the form, the handleSubmit function, and the isSubmitting state.
 * The handlesubmit must be used instead of the form.handleSubmit function.
 * @param form - The form to manage
 * @returns The form, the handleSubmit function, and the isSubmitting state.
 */
export const useManageForm = <T extends FieldValues>(
  form: UseFormReturn<T>,
) => {
  const { handleSubmit, isSubmitting } = useManageSubmit(form);
  return {
    handleSubmit,
    isSubmitting,
    form: { ...form, handleSubmit },
  };
};
